
import { Component, Prop, Vue } from 'vue-property-decorator'

import NewsContent from '@/pages/index/components/MobileTwoNews.vue'
import { NewsMixinManager } from '@/pages/index/components/news-mixin/manager'
import { NewsMixinService } from '@/pages/index/components/news-mixin/service'
@Component({
  components: {
    NewsContent
  }
})
export default class HorizontalMenu extends Vue {
  private menuTitle = [
    { id: '24', title: '市场交流', status: true },
    { id: '25', title: '信息交流', status: false }
    // { id: '22', title: '法律法规', status: false }
  ]

  private id = '24'

  toggleHandler (item: any) {
    this.menuTitle.map((item: any) => {
      item.status = false
      return item
    })
    item.status = true
    this.id = item.id
  }
}
